class ArticleFilter extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', this.click.bind(this));
    this.addEventListener('change', this.change.bind(this));
    this.associatedSection = document.querySelector('section.section-blog-articles')
    this.sectionId = this.associatedSection.getAttribute('id').replace('shopify-section-', '');
    this.filterGroups = this.querySelectorAll('details');
    document.addEventListener('DOMContentLoaded', this.setupPostLoadedEvents.bind(this));
  }

  setupPostLoadedEvents() {
    const paginagtion = this.associatedSection.querySelector('.pagination-wrapper');
    if (!paginagtion) {
      return;
    }

    const observerOptions = {
      root: null, // null means root is viewport
      rootMargin: '0px',
      threshold: 1
    };
    this.observer = new IntersectionObserver(this.paginationIsVisibile.bind(this), observerOptions);

    this.observer.observe(paginagtion);
    paginagtion.addEventListener('click', (event) => {
      event.preventDefault();
      const linkedPageId = event.target.closest('li')?.dataset?.page;
      if (linkedPageId) {
        this.associatedSection.querySelector(`.blog-articles > [data-page="${linkedPageId}"]`)
          .scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });

      }
    }, {
      capture: true
    });
  }

  click(event) {
    // Close other filter groups that might be open else thats ope
    const is_desktop_menu = event.target.closest('nav') !== null;
    if (!is_desktop_menu) {
      return;
    }
    if (event.target.tagName === 'SUMMARY') {
      const details = event.target.parentElement;
      const isOpen = details.hasAttribute('open');
      if (!isOpen) {
        this.filterGroups.forEach((group) => {
          group.removeAttribute('open');
        });
      }
    }
  }

  getTagsToFilterBy() {
    const tags = [...this.querySelectorAll('input:checked')].map((input) => input.value).filter((tag) => tag !== '');
    const uniqueTags = [...new Set(tags)];
    return uniqueTags;
  }

  change(event) {
    const is_desktop_menu = event.target.closest('nav') !== null;
    if (is_desktop_menu) {

      window.setTimeout(function () {
        this.filterGroups.forEach((group) => {
          group.removeAttribute('open');
        });
      }.bind(this), 250);
    }

    const tags = this.getTagsToFilterBy();
    const elementsToReplace = ['.blog-articles', '.pagination-wrapper']
    const tagFilter = (tags.length > 0) ? `/tagged/${tags.join('+')}` : '';
    let url = `${window.location.pathname.split('/tagged')[0]}${tagFilter}`;

    fetch(url + `?sections=${this.sectionId}`)
      .then((response) => response.json())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText[this.sectionId], 'text/html');
        elementsToReplace.forEach((element) => {
          const elementToReplace = this.associatedSection.querySelector(element);
          const updatedHtml = html.querySelector(element)?.innerHTML;
          if (elementToReplace) {
            this.associatedSection.querySelector(element).innerHTML = updatedHtml || '';
          }
        });

        history.replaceState(null, null, url);
      });
  }

  paginationIsVisibile(entries) {
    if (this.fetchingPage || entries[0].isIntersecting === false) {
      return;
    }
    const currentPage = document.querySelector('.pagination li:has(.pagination__item--current');
    if (!currentPage) {
      return;
    }
    const nextPage = currentPage?.nextElementSibling?.querySelector('a')?.href;
    if (!nextPage) {
      return;
    }
    this.associatedSection.querySelector('.pagination-wrapper').classList.add('is-loading');

    fetch(nextPage + `&sections=${this.sectionId}`)
      .then((response) => response.json())
      .then((responseText) => {

        const html = new DOMParser().parseFromString(responseText[this.sectionId], 'text/html');
        const elementsToReplace = ['.pagination-wrapper']
        elementsToReplace.forEach((element) => {
          const elementToReplace = this.associatedSection.querySelector(element);
          const updatedHtml = html.querySelector(element)?.innerHTML;
          if (elementToReplace) {
            if (updatedHtml) {
              this.associatedSection.querySelector(element).innerHTML = updatedHtml;
            }
          }
        });
        const nextPageArticles = html.querySelector('.blog-articles')?.innerHTML;
        if (nextPageArticles) {
          this.associatedSection.querySelector('.blog-articles').insertAdjacentHTML('beforeend', nextPageArticles);
        }
        this.associatedSection.querySelector('.pagination-wrapper').classList.remove('is-loading');
      });
  }
}

customElements.define('article-filter', ArticleFilter);
